import { FC } from 'react';
import { MdDeleteForever } from 'react-icons/md';
import { ExtendableBlock } from '../../../components/extendable-block/extendable-block';
import { IconButton } from '../../../components/icon-button/icon-button';
import { DatePicker } from '../../../features/date-time/date-picker/date-picker';
import { formatToBackDateTime } from '../../../helpers/date-time';
import { useLang } from '../../../hooks/use-lang';
import { SchedulerInterface } from '../types';
import s from './scheduler-specs.module.css';

export const SchedulerSpecs: FC<Partial<SchedulerInterface>> = (props) => {
  const { t } = useLang();

  const updatedSpecs = [...(props.start_date || [''])];

  const handleSelectDate = (date?: Date, index: number = 0) => {
    const stringifiedDate = formatToBackDateTime(date);
    updatedSpecs[index] = stringifiedDate || '';
    props.handleUpdateSpecs?.(updatedSpecs);
  };

  const handleAddSpec = () => {
    updatedSpecs.push('');
    props.handleUpdateSpecs?.(updatedSpecs);
  };

  const handleDeleteSpec = (index: number) => {
    updatedSpecs.splice(index, 1);
    props.handleUpdateSpecs?.(updatedSpecs);
  };

  return (
    <ExtendableBlock
      button={{ variant: 'primary', children: t('Добавить'), onClick: handleAddSpec }}
      className={s.feature}
    >
      {updatedSpecs.map((date, index) => (
        <li key={index} className={s.item}>
          <DatePicker
            selectedDate={date ? new Date(date) : undefined}
            onSelectDate={(date) => handleSelectDate(date, index)}
            required
            name={`spec-date-${index}`}
            placeholder={t('Дата')}
            minDate={new Date()}
          />
          {index > 0 && (
            <IconButton variant="ghost" onClick={() => handleDeleteSpec(index)}>
              <MdDeleteForever />
            </IconButton>
          )}
        </li>
      ))}
    </ExtendableBlock>
  );
};
